export default __webpack_public_path__ + "static/media/drone.5066d73e.jpg";